import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-title" }, " Gestisci Account ", -1)
const _hoisted_4 = { class: "my-card mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold my-card--header" }, " Actions ", -1)
const _hoisted_6 = { class: "my-buttons my-card--body" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Refresh list ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Create a new account ")
const _hoisted_9 = { class: "flex flex-col md:flex-row mb-10 gap-5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Account")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("totali")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Account")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("visti oggi")
const _hoisted_16 = { class: "my-form" }
const _hoisted_17 = { class: "font-bold my-title" }
const _hoisted_18 = { class: "my-form--field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Username", -1)
const _hoisted_20 = { class: "my-form--field--field" }
const _hoisted_21 = { class: "my-form--field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Password", -1)
const _hoisted_23 = { class: "my-form--field--field" }
const _hoisted_24 = { class: "my-form--field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Description", -1)
const _hoisted_26 = { class: "my-form--field--field" }
const _hoisted_27 = { class: "my-form--field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Contact", -1)
const _hoisted_29 = { class: "my-form--field--field" }
const _hoisted_30 = { class: "my-form--field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Role", -1)
const _hoisted_32 = { class: "my-form--field--field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "user" }, "User", -1)
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "my-form--field" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Extradata", -1)
const _hoisted_38 = { class: "my-form--field--field" }
const _hoisted_39 = { class: "my-form--field" }
const _hoisted_40 = { class: "my-form--field--field" }
const _hoisted_41 = { class: "my-form" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold my-title" }, " Edit account machine association ", -1)
const _hoisted_43 = { class: "my-form--field" }
const _hoisted_44 = { class: "my-form--field--field" }
const _hoisted_45 = { class: "my-form--field" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Machine id", -1)
const _hoisted_47 = { class: "my-form--field--field" }
const _hoisted_48 = { class: "my-form--field" }
const _hoisted_49 = { class: "my-form--field--field" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Create association ")
const _hoisted_51 = {
  key: 0,
  class: "my-form--field"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--field" }, " Downloading... ", -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "my-form" }
const _hoisted_55 = { class: "my-form--field" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Search term", -1)
const _hoisted_57 = { class: "my-form--field--field" }
const _hoisted_58 = { class: "my-form--field" }
const _hoisted_59 = { class: "my-form--field--field my-buttons" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Reset ")
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Search ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_StatCard = _resolveComponent("StatCard")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-sync",
            onClick: _ctx.refreshListAccounts
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-plus-circle",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModalCreateAccount()))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            icon: "fas fa-search",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalSearch = true)),
            class: _normalizeClass(_ctx.searchTerm != '' ? 'is-success' : 'is-secondary')
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Search" + _toDisplayString(_ctx.searchTerm != '' ? `: ${_ctx.searchTerm}` : ''), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_StatCard, { class: "" }, {
          stat: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.countAccounts), 1)
          ]),
          label: _withCtx(() => [
            _hoisted_10,
            _hoisted_11,
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_StatCard, { class: "" }, {
          stat: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.countAccountsSeenToday), 1)
          ]),
          label: _withCtx(() => [
            _hoisted_13,
            _hoisted_14,
            _hoisted_15
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_Table, {
        config: _ctx.configTableAccounts,
        data: _ctx.searchTerm != '' ? _ctx.listAccountsFiltered : _ctx.listAccounts,
        onEditAccountData: _cache[2] || (_cache[2] = ($event: any) => {_ctx.openModalEditAccount(); _ctx.idEntityEdit = $event.id_account;}),
        onEditAccountAssociation: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModalAssociation($event.id_account)))
      }, null, 8, ["config", "data"])
    ]),
    _createVNode(_component_Modal, {
      isShowing: _ctx.showModalUpsert,
      onCloseModal: _cache[11] || (_cache[11] = ($event: any) => {_ctx.showModalUpsert = false; _ctx.idEntityEdit = '';})
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.titleModalUpsert), 1),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                class: "my-input",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.upsertUsername) = $event))
              }, null, 512), [
                [_vModelText, _ctx.upsertUsername]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                class: "my-input",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.upsertPassword) = $event)),
                placeholder: "Vuoto per lasciare invariato"
              }, null, 512), [
                [_vModelText, _ctx.upsertPassword]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                class: "my-input",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.upsertDescription) = $event))
              }, null, 512), [
                [_vModelText, _ctx.upsertDescription]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                class: "my-input",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.upsertContact) = $event))
              }, null, 512), [
                [_vModelText, _ctx.upsertContact]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.upsertRoleAccount) = $event)),
                class: "my-select w-full"
              }, [
                _hoisted_33,
                (_ctx.role == 'owner')
                  ? (_openBlock(), _createElementBlock("option", {
                      key: 0,
                      value: "owner",
                      disabled: _ctx.role !== 'owner'
                    }, " Owner ", 8, _hoisted_34))
                  : _createCommentVNode("", true),
                (_ctx.role == 'owner')
                  ? (_openBlock(), _createElementBlock("option", {
                      key: 1,
                      value: "admin",
                      disabled: _ctx.role !== 'owner'
                    }, " Admin ", 8, _hoisted_35))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vModelSelect, _ctx.upsertRoleAccount]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _withDirectives(_createElementVNode("input", {
                class: "my-input",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.upsertExtradata) = $event))
              }, null, 512), [
                [_vModelText, _ctx.upsertExtradata]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_Button, {
                class: "is-primary",
                icon: "fas fa-plus-circle",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.upsertAccount()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.functionModalUpsert === 'create' ? 'Create' : 'Edit'), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShowing"]),
    _createVNode(_component_Modal, {
      isShowing: _ctx.showModalAssociation,
      onCloseModal: _cache[15] || (_cache[15] = ($event: any) => {_ctx.showModalAssociation = false; _ctx.editAssociationAccountId = ''})
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, " Machine associated with the account " + _toDisplayString(_ctx.editAssociationAccountId), 1)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, [
              _withDirectives(_createElementVNode("input", {
                class: "my-input",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editAssociationMachineId) = $event))
              }, null, 512), [
                [_vModelText, _ctx.editAssociationMachineId]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_Button, {
                class: "is-primary",
                icon: "fas fa-plus-circle",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addMachineAssociation()))
              }, {
                default: _withCtx(() => [
                  _hoisted_50
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.isDownloadingMachineAssociations)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
            : _createCommentVNode("", true),
          _createVNode(_component_Table, {
            config: _ctx.configTableAssociations,
            data: _ctx.listMachinesAssociated,
            onRemoveMachineAssociation: _cache[14] || (_cache[14] = ($event: any) => (_ctx.removeMachineAssociation($event.machineId)))
          }, null, 8, ["config", "data"])
        ])
      ]),
      _: 1
    }, 8, ["isShowing"]),
    _createVNode(_component_Modal, {
      isShowing: _ctx.showModalSearch,
      onCloseModal: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showModalSearch = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, [
              _withDirectives(_createElementVNode("input", {
                class: "my-input",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.searchTerm) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchTerm]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_component_Button, {
                class: "is-primary",
                icon: "fas fa-ban",
                onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.listAccountsFiltered = _ctx.listAccounts;
              _ctx.searchTerm = ''; _ctx.typeSearch = ''; _ctx.showModalSearch = false})
              }, {
                default: _withCtx(() => [
                  _hoisted_60
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "is-primary",
                icon: "fas fa-search",
                onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.searchAccounts(); _ctx.showModalSearch = false})
              }, {
                default: _withCtx(() => [
                  _hoisted_61
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShowing"])
  ]))
}